var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscountCouponIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.05369 7.78648C1.84658 7.78648 1.65758 7.6186 1.66709 7.39915C1.72286 6.11408 1.87909 5.2775 2.31682 4.61572C2.56865 4.23499 2.88146 3.90385 3.24111 3.63725C4.21321 2.91669 5.58458 2.91669 8.3273 2.91669H11.6729C14.4156 2.91669 15.787 2.91669 16.7591 3.63725C17.1188 3.90385 17.4315 4.23499 17.6833 4.61572C18.1211 5.27743 18.2773 6.1139 18.3331 7.39871C18.3426 7.61842 18.1533 7.78648 17.946 7.78648C16.7912 7.78648 15.855 8.77752 15.855 10C15.855 11.2225 16.7912 12.2135 17.946 12.2135C18.1533 12.2135 18.3426 12.3816 18.3331 12.6014C18.2773 13.8862 18.1211 14.7226 17.6833 15.3844C17.4315 15.765 17.1188 16.0962 16.7591 16.3628C15.787 17.0834 14.4156 17.0834 11.6729 17.0834H8.3273C5.58458 17.0834 4.21321 17.0834 3.24111 16.3628C2.88146 16.0962 2.56865 15.765 2.31682 15.3844C1.87909 14.7225 1.72286 13.8859 1.66709 12.6009C1.65758 12.3814 1.84658 12.2135 2.05369 12.2135C3.20852 12.2135 4.14468 11.2225 4.14468 10C4.14468 8.77752 3.20852 7.78648 2.05369 7.78648Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91675 12.0834L12.0834 7.91669",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91675 7.91669H7.9261M12.0741 12.0834H12.0834",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountCouponIcon);
export default __webpack_public_path__ + "static/media/discount-coupon-icon.795dca85ad419f48d97a0f2046c2240c.svg";
export { ForwardRef as ReactComponent };